import { BaseDevice } from './BaseDevice';
import { DbConnectedSensorBoolean } from './DbConnectedSensorBoolean';
import { DbConnectedSensorNumber } from './DbConnectedSensorNumber';

export class NotificationDevice extends BaseDevice {
  constructor() {
    super();
  }

  enableNotifications: boolean = false;
  enableSound: boolean = false;
  visible: boolean = false;

  connectedSensorsBoolean: Array<DbConnectedSensorBoolean> = [];
  connectedSensorsNumber: Array<DbConnectedSensorNumber> = [];
}